export const invertedMessages = {
  'To Do': 'CERTS_TODO',
  Done: 'CERTS_DONE',
  Consulted: 'CERTS_CONSULTED',
  All: 'CERTS_ALL',
};
